import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=3d9eb981&scoped=true&"
import script from "./BarcodeScanner.vue?vue&type=script&lang=ts&"
export * from "./BarcodeScanner.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=3d9eb981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9eb981",
  null
  
)

export default component.exports